<mat-card class="page-content">
  <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="16px">
    <div class="mat-display-1 page-content-title">U wordt doorverwezen</div>
  </div>
</mat-card>